// extracted by mini-css-extract-plugin
export default {"mfaInputBlock":"Dialog__mfaInputBlock__CCWsH","mobileHidden":"Dialog__mobileHidden__I7lsm","confirmMfaButton":"Dialog__confirmMfaButton__MlAj1"};